// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-tag-field .wrapper{padding:4px;border-radius:4px;border:1px solid #d9d9d9;height:36px;line-height:22px;padding:6px 12px}.lc-am-tag-field .button-new-tag,.lc-am-tag-field .yxt-tag+.yxt-tag{margin-left:10px}.lc-am-tag-field .input-new-tag{width:90px;margin-left:10px;vertical-align:bottom}", ""]);
// Exports
module.exports = exports;
